<template>
  <b-container fluid class="mb-6 mt-6 p-0">
    <b-row>
      <b-col>
        <div class="card card-custom gutter-b">
          <div class="mt-0">
            <template-table
              :column="column"
              :data="data"
              :paging="paging"
              :tableAction="false"
              :selectAction="false"
              :searchAction="false"
            >
              <template v-slot:body="{ item }">
                <td>
                  <span class="font-weight-bolder">
                    {{
                      $moment(item.createDate * 1000).format(
                        'HH:mm, DD/MM/YYYY ',
                      )
                    }}</span
                  >
                </td>
                <td>
                  <span class="font-weight-bolder"> {{ item.timeFrame }} </span>
                </td>
                <td>
                  <span
                    :style="`color:${item.backgroundColor}`"
                    class="font-weight-bolder"
                  >
                    {{ item.glucose }}
                  </span>
                  <span class="unit">{{ item.unit }}</span>
                </td>
                <td>
                  <span class="font-weight-bolder"> {{ item.note }}</span>
                </td>
                <td>
                  <div
                    v-if="item.healthRecommendation"
                    class="ai-advice"
                    :class="{ 'ai-advice--open': expandedAdvice[item.id] }"
                    title="Bấm để xem đầy đủ / thu gọn"
                    @click="$set(expandedAdvice, item.id, !expandedAdvice[item.id])"
                  >
                    {{ item.healthRecommendation }}
                  </div>
                </td>
                <td>
                  <div class="d-flex">
                    <div
                      class="preview"
                      v-for="(image, index) in item.images"
                      :key="index"
                    >
                      <img
                        @click.stop="handlePreview(image.url)"
                        :src="image.url"
                        class="preview-image"
                        alt=""
                      />
                    </div>
                  </div>
                </td>
              </template>
            </template-table>
          </div>
          <image-preview :image.sync="imagePreview" />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { fetchAllPages } from '../exportExcel';
export default {
  name: 'BloodSugar',
  components: {
    'image-preview': () => import('../components/ModalPreview.vue'),
  },
  props: {
    time: {
      type: Object,
    },
    idUser: {
      type: [String, Number],
    },
  },
  data() {
    return {
      column: [
        {
          key: 'dateInput',
          label: 'Ngày nhập',
          sortable: false,
        },
        {
          key: 'timeFrame',
          label: 'Khung giờ',
          sortable: false,
        },
        {
          key: 'differentPercentage',
          label: 'Kết quả',
          sortable: false,
        },
        {
          key: 'note',
          label: 'Ghi chú',
          sortable: false,
        },
        {
          key: 'healthRecommendation',
          label: 'Gợi ý AI',
          sortable: false,
        },
        {
          key: 'thumbnail',
          label: 'Hình ảnh',
          sortable: false,
        },
      ],
      data: [],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      imagePreview: null,
      expandedAdvice: {},
      searchParams: {
        currentDateTime: parseInt(new Date().getTime() / 1000),
        periodFilterType: 1,
      },
    };
  },
  computed: {
    id() {
      return this.idUser;
    },
  },
  watch: {
    paging: {
      handler(newVal) {
        if (newVal) {
          this.loadData();
        }
      },
      deep: true,
    },
    time: {
      handler(newVal) {
        this.searchParams.periodFilterType = newVal.value;
        this.loadData();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async exportRows() {
      const data = await fetchAllPages(this.$api, 'Admin/Glucose/Input', {
        ...this.searchParams,
        patientId: this.id,
      });
      return {
        columns: ['Ngày nhập', 'Khung giờ', 'Kết quả', 'Đơn vị', 'Ghi chú', 'Gợi ý AI', 'Hình ảnh'],
        rows: (data || []).map((e) => [
          this.$moment(e.createDate * 1000).format('HH:mm DD/MM/YYYY'),
          e.timeFrame,
          e.glucose,
          e.unit,
          e.note,
          e.healthRecommendation,
          (e.images || []).map((i) => i.url).join('\n'),
        ]),
      };
    },
    handlePreview(image) {
      this.imagePreview = image;
      this.$bvModal.show('image-preview');
    },

    loadData() {
      this.$store.commit('context/setLoading', true);
      this.$api
        .get('Admin/Glucose/Input', {
          params: {
            ...this.searchParams,
            ...this.paging,
            size: this.paging.pageSize,
            patientId: this.id,
          },
        })
        .then(({ meta, data }) => {
          this.data = data || [];

          this.paging.total = meta.total;
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
        })
        .finally(() => {
          this.$store.commit('context/setLoading', false);
        });
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
.unit {
  color: #b5b5c3;
}
.ai-advice {
  max-width: 360px;
  cursor: pointer;
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ai-advice--open {
  display: block;
}
.preview {
  cursor: pointer;
  width: 40px;
  height: 40px;
}
.preview:not(:first-child) {
  margin-left: 10px;
}
.preview-image {
  border-radius: 6px;
  display: block;
  width: 100%;
  object-fit: cover;
  height: 100%;
}
</style>
